export default "__VITE_ASSET__55993c15__"